module.exports = __webpack_public_path__ + "img/icon_file_off.a1d007b9.svg";